import { __awaiter, __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import * as ClipboardWeb from 'clipboard/dist/clipboard.min.js';
import { ToastController, IonicModule } from '@ionic/angular';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { CommonModule } from '@angular/common';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCBilletReviewComponent = class UiCBilletReviewComponent {
    constructor(toastCtrl, clipboardApp) {
        this.toastCtrl = toastCtrl;
        this.clipboardApp = clipboardApp;
        this.shareBilletOnPage = new EventEmitter();
        this.printBilletOnPage = new EventEmitter();
        this.dismiss = new EventEmitter();
        this.clipboardWeb = new ClipboardWeb('#copyBtn');
        this.clipboardWeb.on('success', () => {
            this.toastCopy();
        });
    }
    copyBilletCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: 'Código de depósito copiado com sucesso',
                duration: 2000
            });
            toast.present();
            this.clipboardApp.copy(this.billetCode);
        });
    }
    shareBillet() {
        this.shareBilletOnPage.emit();
    }
    printBillet() {
        this.printBilletOnPage.emit();
    }
    dismissEvent() {
        this.dismiss.emit();
    }
    toastCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: 'Dados copiados!',
                duration: 2000
            });
            toast.present();
        });
    }
    ngOnInit() { }
};
UiCBilletReviewComponent.ctorParameters = () => [
    { type: ToastController },
    { type: Clipboard }
];
__decorate([
    Input()
], UiCBilletReviewComponent.prototype, "rechargeValue", void 0);
__decorate([
    Input()
], UiCBilletReviewComponent.prototype, "billetCode", void 0);
__decorate([
    Input()
], UiCBilletReviewComponent.prototype, "hasCancelButton", void 0);
__decorate([
    Input()
], UiCBilletReviewComponent.prototype, "hasShareButton", void 0);
__decorate([
    Input()
], UiCBilletReviewComponent.prototype, "hasPrintButton", void 0);
__decorate([
    Output()
], UiCBilletReviewComponent.prototype, "shareBilletOnPage", void 0);
__decorate([
    Output()
], UiCBilletReviewComponent.prototype, "printBilletOnPage", void 0);
__decorate([
    Output()
], UiCBilletReviewComponent.prototype, "dismiss", void 0);
UiCBilletReviewComponent = __decorate([
    Component({
        selector: 'ui-c-billet-review',
        template: "<div class=\"billet-review\">\n  <div class=\"recharge-col mt-5 d-flex flex-column align-items-center justify-content-around\">\n    <div class=\" ion-text-center\">\n      <h2 class=\"font-weight-bold\">{{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.DESCRIPTION.PRIMARY' | wlpTranslate}}</h2>\n    </div>\n    <p class=\"d-flex align-items-end\">\n      <span class=\"align-self-start\">R$</span>\n      <span class=\"recharge-money\">{{rechargeValue}}</span>\n    </p>\n    <div class=\"d-flex align-items-center\">\n      <ion-button fill=\"clear\" color=\"dark\" id=\"copyBtn\" (click)=\"copyBilletCode()\" data-clipboard-target=\"#copyTarget\">\n        <div class=\"d-flex flex-column\">\n          <div>\n            <ion-icon class=\"icon-size\" [name]=\"'copy-outline'\"></ion-icon>\n          </div>\n          <div>\n            <span class=\"text-capitalize\">{{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.COPY' | wlpTranslate}}</span>\n          </div>\n        </div>\n      </ion-button>\n      <p class=\"d-flex flex-column billet-code-p-tag\">\n      <span class=\"font-weight-bold\">\n        {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BILLET_CODE' | wlpTranslate}}\n      </span>\n        <span id=\"copyTarget\">\n        {{billetCode}}\n      </span>\n      </p>\n    </div>\n  </div>\n\n  <div class=\"group-buttons\">\n    <div class=\"container content-below\">\n      <ion-row>\n        <ion-col size=\"12\" class=\"ion-padding\">\n          <ui-c-button *ngIf=\"hasPrintButton\" class=\"btn-green\" expand=\"block\" (continue)=\"printBillet()\">\n          <span class=\"title\">\n            {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BUTTON.PRINT' | wlpTranslate}}\n          </span>\n          </ui-c-button>\n          <div class=\"mt-1\" *ngIf=\"hasShareButton\">\n            <ui-c-button class=\"blue-button\" expand=\"block\" (continue)=\"shareBillet()\">\n            <span class=\"title\">\n              {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BUTTON.SHARE' | wlpTranslate}}\n            </span>\n            </ui-c-button>\n          </div>\n          <div class=\"mt-1\" *ngIf=\"hasCancelButton\">\n            <ui-c-button class=\"cancel-button\" expand=\"block\" (continue)=\"dismissEvent()\">\n            <span class=\"title\">\n              {{'CASH_IN.ACCOUNT_RECHARGE_REVIEW.BUTTON.CANCEL' | wlpTranslate}}\n            </span>\n            </ui-c-button>\n          </div>\n        </ion-col>\n      </ion-row>\n    </div>\n  </div>\n</div>\n",
        styles: [""]
    })
], UiCBilletReviewComponent);

let UiCBilletReviewModule = class UiCBilletReviewModule {
};
UiCBilletReviewModule = __decorate([
    NgModule({
        declarations: [
            UiCBilletReviewComponent
        ],
        imports: [
            CommonModule,
            IonicModule,
            UiCButtonModule,
            UiBsTranslateModule
        ],
        providers: [
            Clipboard
        ],
        exports: [
            UiCBilletReviewComponent
        ]
    })
], UiCBilletReviewModule);

/*
 * Public API Surface of ui-c-billet-review
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCBilletReviewComponent, UiCBilletReviewModule };
//# sourceMappingURL=wlp-ui-c-billet-review.js.map
